import translate from '@/lib/intl/translate';

const RelationNamesSingular = Object.freeze({
  employees: translate('RELATION_SINGULAR_EMPLOYEES'),
  employers: translate('RELATION_SINGULAR_EMPLOYERS'),
  household: translate('RELATION_SINGULAR_HOUSEHOLD'),
  affiliations: translate('RELATION_SINGULAR_AFFILIATIONS'),
  connections: translate('RELATION_SINGULAR_CONNECTIONS'),
});

export default RelationNamesSingular;
